<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">
								{{ oid ? "Edit CAPA Request" : "Create CAPA Request" }}
							</div>
							<!--页头-->
							<div class="page_main">
								<div class="training-cert-page">
									<div class="btn_el">
										<div class="tips">
											Please provide complete information for the new request
											and submit it for review.
										</div>
									</div>
									<!--表单-->
									<el-form ref="form" :model="form" :rules="rules" label-position="top"
										class="training-form">
										<!-- Description of Issue, Concern, Idea, or Opportunity -->
										<el-form-item label="Description of Issue, Concern, Idea, or Opportunity"
											prop="description">
											<el-input type="textarea" :rows="3" v-model="form.description"
												placeholder="Please enter" maxlength="" clearable />
										</el-form-item>
										<!-- <el-form-item label="Company" prop="company_id">
											<div class="dept-row">
												<el-select v-model="form.company_id"
													placeholder="Please select a company" class="full-width"
													style="width: 100%" @change="getDepartment(form.company_id)">
													<el-option v-for="value in companyList" :key="value.id"
														:label="value.company_name" :value="value.id"></el-option>
												</el-select>
											</div>
										</el-form-item> -->
										<el-form-item label="Department" prop="departments_id">
											<div class="dept-row">
												<el-select v-model="form.departments_id"
													placeholder="Please select a department" class="full-width"
													style="width: 100%">
													<el-option v-for="value in departmentsList" :key="value.id"
														:label="value.departments_name" :value="value.id"></el-option>
												</el-select>
											</div>
										</el-form-item>
										<!-- Source Type -->
										<el-form-item label="Source Type" prop="source_type">
											<el-select v-model="form.source_type" placeholder="Please select"
												style="width: 100%">
												<el-option label="Calibration" value="Calibration" />
												<el-option label="Change Request" value="Change Request" />
												<el-option label="Clinical" value="Clinical" />
												<el-option label="Complaint" value="Complaint" />
												<el-option label="Design Control" value="Design Control" />
												<el-option label="Environmental" value="Environmental" />
												<el-option label="External Audit" value="External Audit" />
												<el-option label="Improvement Opportunity"
													value="Improvement Opportunity" />
												<el-option label="Internal Audit" value="Internal Audit" />
												<el-option label="Issue" value="Issue" />
												<el-option label="Maintenance" value="Maintenance" />
												<el-option label="Management Review" value="Management Review" />
												<el-option label="Nonconforming Material"
													value="Nonconforming Material" />
												<el-option label="Supplier Audit" value="Supplier Audit" />
												<el-option label="Other" value="Other" />
											</el-select>
										</el-form-item>
										<!-- Source Information -->
										<el-form-item label="Source Information" prop="source_info">
											<el-input v-model="form.source_info" placeholder="Please enter" maxlength=""
												clearable />
										</el-form-item>
									</el-form>
									<!-- CAPA Background Files -->
									<div class="btn_el">
										<div class="tips">
											Please attach any files containing background information
											for this CAPA request.
										</div>
									</div>
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">CAPA Background Files</div>
										</div>
										<el-table ref="fileTable" :data="tableData1" empty-text="No Data" border>
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="name" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Actions" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove1(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="file-action-row">
											<el-button size="small" type="primary" @click="handleAddCAPAFile">
												Add CAPA Background File
											</el-button>
										</div>
									</div>
									<br />
									<!--Affected Items-->
									<div class="btn_el">
										<div class="tips">
											Add any items affected by the issue, concern, idea, or
											opportunity (e.g., documents, parts, tools, equipment,
											etc.).
										</div>
									</div>
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">
												Items Affected by the Issue, Concern, Idea, or
												Opportunity
											</div>
										</div>
										<el-table ref="fileTable" :data="tableData2" empty-text="No Data" border>
											<el-table-column prop="" label="Item Type" min-width="180" sortable>
												<template #default="scope">
													<div v-if="scope.row.article_type == 1">Document</div>
													<div v-if="scope.row.article_type == 2">
														Equipment
													</div>
													<div v-if="scope.row.article_type == 3">Product</div>
													<div v-if="scope.row.article_type == 4">Tool</div>
													<div v-if="scope.row.article_type == 5">Other</div>
												</template>
											</el-table-column>
											<el-table-column prop="article_id" label="Item ID" min-width="110"
												sortable />
											<el-table-column prop="article_name" label="Item Name" min-width="110"
												sortable />
											<el-table-column prop="article_revision" label="Item Revision"
												min-width="140" sortable></el-table-column>
											<el-table-column prop="" label="Serial Number" min-width="180" sortable>
												<template #default="scope">
													{{ scope.row.serial_number || "N/A" }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Lot Number" min-width="160" sortable>
												<template #default="scope">
													{{ scope.row.lot_number || "N/A" }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Purchased Product?" min-width="180"
												sortable>
												<template #default="scope">
													<div v-if="scope.row.is_buy == 1">Yes</div>
													<div v-if="scope.row.is_buy == 2">No</div>
													<div v-else></div>
												</template>
											</el-table-column>
											<el-table-column prop="" label="Supplier" min-width="120" sortable>
												<template #default="scope">
													{{ scope.row.supplier_name || "" }}
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Actions" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove2(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="file-action-row">
											<el-button size="small" type="primary" @click="handleAffectedArticle">
												Add Affected Item
											</el-button>
										</div>
									</div>
									<br />
									<!--Correction-->
									<div class="btn_el">
										<div class="tips">
											Record actions taken to contain or eliminate identified
											nonconformities.
										</div>
									</div>
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">Correction</div>
										</div>
										<el-table ref="fileTable" :data="tableData3" empty-text="No Data" border>
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Actions" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove3(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="file-action-row">
											<el-button size="small" type="primary" @click="handleAddCorrection">
												Add Correction
											</el-button>
										</div>
									</div>
									<div class="footer-actions">
										<el-button v-if="step != 4" type="primary" @click="handleComplete">
											Save & Continue
										</el-button>
										<el-button type="primary" @click="handleSaveDraft('form')">
											Save for Later
										</el-button>
										<el-button @click="handleCancel"> Cancel </el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--添加文件弹窗-->
		<el-dialog :title="dialogVisibleTitle" :visible.sync="dialogVisible" width="50%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form ref="ruleForm" :model="ruleForm" :rules="rules1" label-position="top" class="upload-form">
						<!-- Description -->
						<el-form-item label="Description" prop="description">
							<el-input v-model="ruleForm.description" type="textarea" :rows="5" resize="none"
								placeholder="Please enter a description" />
						</el-form-item>
						<!-- 附件 -->
						<el-form-item prop="">
							<div class="upload-doc-wrapper">
								<div class="upload-title required-title">
									<span> File to Upload </span>
									<span class="upload-limit"> （Maximum 10 MB） </span>
								</div>
								<div class="upload-box" style="position: relative">
									<el-upload ref="uploadBox" class="doc-upload" action="/" name="files"
										:show-file-list="false" :before-upload="beforeAvatarUpload"
										:on-change="handleAvatarChange" :limit="1" :with-credentials="true"
										:auto-upload="false">
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No file selected" }}
										<span v-if="fileName" style="
                        position: absolute;
                        right: 20px;
                        top: 12px;
                        cursor: pointer;
                        color: #f00;
                      " @click="delFile">Delete</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">
						Cancel
					</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--添加文件弹窗-->
		<!--Sign弹框-->
		<el-dialog title="Sign New Request" :visible.sync="dialogVisible1" width="30%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form :model="ruleForm1" :rules="rules2" ref="ruleForm1" label-width="0px">
						<div class="input_el">
							<div class="tit">Comments</div>
							<el-form-item label="" prop="remark">
								<el-input type="textarea" :rows="3" v-model="ruleForm1.remark"
									placeholder="Please enter" clearable></el-input>
							</el-form-item>
						</div>
						<div class="input_el">
							<div class="tit required">Password</div>
							<el-form-item label="" prop="signature">
								<el-input v-model="ruleForm1.signature" placeholder="Please enter" clearable
									show-password></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible1 = false">Cancel</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm1('ruleForm1')">Sign</van-button>
				</div>
			</div>
		</el-dialog>
		<!--Sign弹框-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import {
		capaSubmit,
		capaUploadsCapaBackgroundFile,
		capaUploadsCapaBackgroundFileDel,
		capaUploadsCapaCorrectionsFile,
		capaUploadsCapaCorrectionsFileDel,
		capaUploadsCapaAffectedArticleDel,
		ApplyHandle,
	} from "@/api/capaManage/capaRequest/index";
	import {
		resourcesApplyDetail
	} from "@/api/docManage/changeRequest/index";
	// import {
	// 	companyList
	// } from "@/api/system/company";
	import {
		departmentsList
	} from "@/api/system/department";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import moment from "moment";
	import md5 from "js-md5";
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				dialogVisibleTitle: "",
				dialogVisible: false,
				dialogVisible1: false,
				fileName: "",
				selectedFile: null,
				form: {
					id: "",
					flow_type: "capa",
					description: "",
					// company_id: "",
					departments_id: "",
					source_type: "",
					source_info: "",
				},
				rules: {
					description: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
					// company_id: [{
					// 	required: true,
					// 	message: "Please select",
					// 	trigger: "change",
					// }, ],
					departments_id: [{
						required: true,
						message: "Please select",
						trigger: "change",
					}, ],
					source_type: [{
						required: true,
						message: "Please select",
						trigger: "change",
					}, ],
					source_info: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
				},
				tableData1: [],
				tableData2: [],
				tableData3: [],
				// companyList: [],
				departmentsList: [],
				userToken: localStorage.getItem("userToken"),
				ruleForm: {
					capa_id: "",
					description: "",
					files: "",
				},
				rules1: {
					description: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
				},
				ruleForm1: {
					remark: "",
					signature: "",
				},
				rules2: {
					signature: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
				},
				oid: null,
				step: null,
			};
		},
		created() {
			let that = this;
			that.oid = that.$route.query.oid;
			that.step = that.$route.query.step;
		},
		mounted() {
			let that = this;
			//请求公司列表
			// companyList({
			// 	page: 1,
			// 	page_size: 9999,
			// 	status: 1,
			// 	company_name: "",
			// 	company_userid: "",
			// 	manage_userid: "",
			// }).then((res2) => {
			// 	if (res2.code == 200) {
			// 		that.companyList = res2.data.data;
			// 		//请求详情
			// 		if (that.oid) {
			// 			that.getPageInfo();
			// 		}
			// 	}
			// });
			//请求详情
			if (that.oid) {
				that.getPageInfo();
			}else {
				that.getDepartment();
			}
			that.isLoading = false;
		},
		methods: {
			//请求页面详情
			getPageInfo() {
				let that = this;
				resourcesApplyDetail({
					id: that.oid
				}).then((res) => {
					if (res.code == 200) {
						that.form.id = res.data.id;
						that.form.description = res.data.description;
						// that.form.company_id = res.data.company_id;
						that.form.source_type = res.data.source_type;
						that.form.source_info = res.data.source_info;
						that.getDepartment(res.data.departments_id); //回显部门
						//回显CAPA背景文件
						that.tableData1 = res.data.capabackground_list;
						//回显更正文件
						that.tableData3 = res.data.capacorrections_list;
						//回显受影响的文章
						that.tableData2 = res.data.capaarticle_list;
					}
				});
			},
			//时间戳转换
			initTime(value) {
				if (value) {
					return moment(value * 1000).format("YYYY-MM-DD");
				}
			},
			//请求部门列表
			getDepartment(val) {
				let that = this;
				that.form.departments_id = "";
				that.departmentsList = [];
				that.$toast.loading({
					duration: 0,
					forbidClick: true,
				});
				departmentsList({
					page: 1,
					page_size: 9999,
					status: 1,
					departments_name: "",
					// company_id: value,
					departments_userid: "",
				}).then((res2) => {
					that.$toast.clear();
					that.departmentsList = res2.data.data;
					if (val) {
						that.form.departments_id = Number(val);
					}
				});
			},
			// 添加CAPA背景文件
			handleAddCAPAFile() {
				let that = this;
				if (that.form.id) {
					that.openFileDialog("Add CAPA Background File");
				} else {
					that.$message.warning("Please create a CAPA Request first");
				}
			},
			// 添加更正文件
			handleAddCorrection() {
				let that = this;
				if (that.form.id) {
					that.openFileDialog("Add Correction File");
				} else {
					that.$message.warning("Please create a CAPA Request first");
				}
			},
			handleAffectedArticle() {
				let that = this;
				if (that.form.id) {
					that.$router.push({
						path: "/CapaControl/addAffectedArticles",
						query: {
							oid: that.oid
						},
					});
				} else {
					that.$message.warning("Please create a CAPA Request first");
				}
			},
			handleAvatarChange(file, fileList) {
				let that = this;
				if (!file && !fileList) return;
				that.selectedFile = file.raw;
				that.fileName = file.name;
				that.$toast.clear();
			},
			beforeAvatarUpload(file) {
				let that = this;
				const maxSize = 10 * 1024 * 1024; // 10MB
				const isLt100M = file.size <= maxSize;
				if (!isLt100M) {
					that.$message.error("The uploaded file size cannot exceed 10 MB.");
					return false;
				}
				that.$toast.loading({
					duration: 0,
					forbidClick: true,
				});
			},
			//保存稍后
			handleSaveDraft(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						capaSubmit(that.form).then((res) => {
							if (res.code == 200) {
								that.$toast.clear();
								that.$message.success("Operation Successful");
								setTimeout(() => {
									that.$router.push({
										path: "/task-list"
									});
								}, 800);
							}
						});
					} else {
						return false;
					}
				});
			},
			//保存并继续
			handleComplete() {
				let that = this;
				that.dialogVisible1 = true;
			},
			//删除文件-CAPA背景文件
			handleRemove1(value) {
				let that = this;
				that
					.$confirm(
						"Are you sure you want to delete this CAPA Background File?",
						"Confirmation", {
							type: "warning",
						}
					)
					.then(() => {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						capaUploadsCapaBackgroundFileDel({
							id: value.id
						}).then((res) => {
							if (res.code == 200) {
								that.$toast.clear();
								that.$message.success("Operation Successful");
								setTimeout(() => {
									that.getPageInfo();
								}, 800);
							}
						});
					})
					.catch(() => {});
			},
			//删除文件-更正文件
			handleRemove3(value) {
				let that = this;
				that
					.$confirm(
						"Are you sure you want to delete this affected article?",
						"Confirmation", {
							type: "warning",
						}
					)
					.then(() => {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						capaUploadsCapaCorrectionsFileDel({
							id: value.id
						}).then((res) => {
							if (res.code == 200) {
								that.$toast.clear();
								that.$message.success("Operation Successful");
								setTimeout(() => {
									that.getPageInfo();
								}, 800);
							}
						});
					})
					.catch(() => {});
			},
			//删除文件-受影响的文章
			handleRemove2(value) {
				let that = this;
				that
					.$confirm(
						"Are you sure you want to delete this Correction File?",
						"Confirmation", {
							type: "warning",
						}
					)
					.then(() => {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						capaUploadsCapaAffectedArticleDel({
							id: value.id
						}).then((res) => {
							if (res.code == 200) {
								that.$toast.clear();
								that.$message.success("Operation Successful");
								setTimeout(() => {
									that.getPageInfo();
								}, 800);
							}
						});
					})
					.catch(() => {});
			},
			openFileDialog(name) {
				let that = this;
				that.dialogVisibleTitle = name;
				that.dialogVisible = true;
				that.ruleForm = {
					files: "",
					description: "",
					capa_id: "",
				};
				that.fileName = "";
				that.selectedFile = null;
				that.$nextTick(() => {
					if (that.$refs.ruleForm) {
						that.$refs.ruleForm.clearValidate();
					}
					if (that.$refs.uploadBox) {
						that.$refs.uploadBox.clearFiles();
					}
				});
			},
			//上传文件确定
			submitForm(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						if (!that.selectedFile) {
							that.$message.warning("Please upload a file");
							return false;
						}
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						const formData = new FormData();
						//上传文件
						switch (that.dialogVisibleTitle) {
							case "Add CAPA Background File":
								formData.append("files", that.selectedFile);
								formData.append("description", that.ruleForm.description);
								formData.append("capa_id", that.form.id);
								formData.append("id", "");
								capaUploadsCapaBackgroundFile(formData).then((res) => {
									if (res.code == 200) {
										that.$toast.clear();
										that.$message.success("Operation Successful");
										setTimeout(() => {
											that.dialogVisible = false;
											//请求页面详情
											that.getPageInfo();
										}, 800);
									}
								});
								break;
							case "Add Correction File":
								formData.append("files", that.selectedFile);
								formData.append("description", that.ruleForm.description);
								formData.append("capa_id", that.form.id);
								formData.append("id", "");
								capaUploadsCapaCorrectionsFile(formData).then((res) => {
									if (res.code == 200) {
										that.$toast.clear();
										that.$message.success("Operation Successful");
										setTimeout(() => {
											that.dialogVisible = false;
											//请求页面详情
											that.getPageInfo();
										}, 800);
									}
								});
								break;
						}
					} else {
						return false;
					}
				});
			},
			//签名确定
			submitForm1(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						//保存
						capaSubmit(that.form).then((res) => {
							if (res.code == 200) {
								that.oid = res.data.apply_id;
								that.form.id = res.data.capa_id;
								// console.log(res.data);
								//签名
								ApplyHandle({
									id: that.oid,
									status: 2,
									remark: that.ruleForm1.remark,
									signature: md5(that.ruleForm1.signature + "AiisoQms2026"),
								}).then((res2) => {
									if (res2.code == 200) {
										that.$toast.clear();
										that.$message.success("Operation Successful");
										setTimeout(() => {
											that.$router.push({
												path: "/task-list"
											});
										}, 800);
									}
								});
							}
						});
					} else {
						return false;
					}
				});
			},
			//删除文件
			delFile() {
				let that = this;
				that.selectedFile = null;
				that.fileName = "";
				that.$refs.uploadBox.clearFiles();
			},
			handleCancel() {
				let that = this;
				that.$router.back();
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	.save_box {
		.btn_box {
			text-align: right;

			.btn_el {
				margin-left: 10px;
				padding: 12px 24px;

				.van-button__text {
					font-size: 16px;
				}
			}
		}

		.form_box {
			.input_el {
				.tit {
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}

				.required::before {
					content: "*";
					color: red;
					margin-right: 2px;
				}
			}
		}
	}

	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.training-cert-page {
		padding: 10px;
		background: #fff;
		min-height: 100%;
		box-sizing: border-box;
	}

	.page-title {
		font-size: 18px;
		font-weight: 700;
		color: #303133;
		margin-bottom: 10px;
	}

	.card-block {
		margin-bottom: 12px;
	}

	.upload-doc-wrapper {
		width: 100%;
		margin-bottom: 40px;
		box-sizing: border-box;
	}

	.upload-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 14px;
		font-weight: 500;
	}

	.required-title {
		position: relative;
		padding-left: 10px;
	}

	.required-title::before {
		content: "*";
		position: absolute;
		left: 0;
		top: 3px;
		color: #f56c6c;
		font-size: 15px;
	}

	.upload-limit {
		color: #666;
		font-weight: 400;
	}

	.upload-box {
		display: flex;
		align-items: center;
		width: 100%;
		height: 44px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		overflow: hidden;
		background: #f5f7fa;
	}

	.doc-upload {
		flex-shrink: 0;
	}

	.file-name {
		flex: 1;
		height: 44px;
		line-height: 44px;
		padding: 0 16px;
		font-size: 15px;
		color: #333;
		background: #f5f7fa;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
	}

	.file-name.placeholder {
		color: #999;
	}

	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.search-input {
		width: 180px;
	}

	.form-block {
		margin-bottom: 14px;
	}

	.form-label {
		font-size: 14px;
		color: #606266;
		margin-bottom: 6px;
		font-weight: 600;
	}

	.section-title {
		font-size: 16px;
		font-weight: 700;
		color: #303133;
	}

	.file-action-row {
		margin-top: 10px;
		display: flex;
		gap: 10px;
	}

	.footer-actions {
		margin-top: 26px;
		display: flex;
		justify-content: center;
		gap: 12px;
	}

	.file-list-inline {
		margin: 0;
		padding-left: 0px;
	}

	.file-list-inline li {
		line-height: 20px;
	}

	/* 更接近截图的表格视觉 */
	::v-deep .el-table th {
		padding: 10px 0;
	}

	::v-deep .el-table td {
		padding: 10px 0;
	}

	::v-deep .el-table .current-row>td {
		background-color: #eef3ff !important;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}
</style>